<template>
    <admin-layout :sectionTitle="sectionTitle">
        <!--<div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">Comuni</h1>
        </div>

        <div class="col-sm-auto">
          <button type="button" data-toggle="modal" data-target="#municipalities-create" class="btn btn-primary">Aggiungi comune</button>
        </div>
      </div>
    </div>-->

        <div class="card">
            <div class="card-header">
                <div
                    class="row justify-content-between align-items-center flex-grow-1"
                >
                    <div class="col-sm-6 col-md-4 mb-3 mb-sm-0">
                        <form>
                            <!-- Search -->
                            <div
                                class="input-group input-group-merge input-group-flush"
                            >
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="tio-search"></i>
                                    </div>
                                </div>
                                <input
                                    id="datatableSearch"
                                    type="search"
                                    class="form-control"
                                    placeholder="Cerca comune"
                                    aria-label="Cerca comune"
                                />
                            </div>
                            <!-- End Search -->
                        </form>
                    </div>
                    <div class="col-sm-auto">
                        <button
                            type="button"
                            data-toggle="modal"
                            data-target="#municipalities-create"
                            class="btn btn-primary"
                        >
                            Aggiungi comune
                        </button>
                    </div>
                </div>
            </div>

            <div class="table-responsive datatable-custom">
                <table
                    id="datatable"
                    class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
                >
                    <thead class="thead-light">
                        <tr>
                            <th>Comune</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-for="municipality in $page.props.municipalities
                                .data"
                        >
                            <td>
                                <strong>{{ municipality.name }}</strong>
                            </td>
                            <td>
                                <label
                                    class="toggle-switch toggle-sm mx-2"
                                    :for="`customSwitch-${municipality.id}`"
                                >
                                    <input
                                        type="checkbox"
                                        @change="
                                            updateStatus(municipality, $event)
                                        "
                                        class="js-toggle-switch toggle-switch-input"
                                        :id="`customSwitch-${municipality.id}`"
                                        :checked="municipality.active"
                                    />
                                    <span class="toggle-switch-label">
                                        <span
                                            class="toggle-switch-indicator"
                                        ></span>
                                    </span>
                                </label>
                            </td>
                            <td class="actions">
                                <a
                                    class="btn btn-sm p-0 btn-link"
                                    :href="
                                        route(
                                            'municipalities.show',
                                            municipality.id
                                        )
                                    "
                                >
                                    <i class="tio-visible-outlined"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <div
                    class="row justify-content-center justify-content-sm-between align-items-sm-center"
                >
                    <div class="col-sm mb-2 mb-sm-0">
                        <div
                            class="d-flex justify-content-center justify-content-sm-start align-items-center"
                        >
                            <span class="text-secondary"
                                >{{
                                    pagination.current_page *
                                        pagination.data.length
                                }}
                                di {{ pagination.total }} comuni</span
                            >
                        </div>
                    </div>

                    <div
                        v-if="pagination.per_page < pagination.total"
                        class="col-sm-auto"
                    >
                        <div
                            class="d-flex justify-content-center justify-content-sm-end"
                        >
                            <!-- Pagination -->
                            <pagination :pagination="pagination" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <municipality-create />
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import MunicipalityCreate from "@/Pages/Admin/Municipalities/Create";
import Pagination from "@/Layouts/Partials/Pagination";

export default {
    components: {
        AdminLayout,
        MunicipalityCreate,
        Pagination
    },

    props: ["sectionTitle"],

    data() {
        return {
            pagination: this.$page.props.municipalities,
            form: this.$inertia.form({
                active: false
            })
        };
    },

    mounted() {
        $(".js-toggle-switch").each(function() {
            var toggleSwitch = new HSToggleSwitch($(this)).init();
        });
    },

    methods: {
        updateStatus(municipality, ev) {
            this.form.name = municipality.name;
            this.form.active = ev.target.checked;

            this.$inertia.put(
                route("municipalities.update", municipality.id),
                this.form,{
                    onSuccess: (data) => {
                        console.log('success', data);
                    },
                    onError: (data) => {
                        console.log('error', data);
                    }
                }
            );
            // this.form.put(route("municipalities.update", municipality.id), {
            //     onSuccess: () => {}
            // });
        }
    }
};
</script>
